import type { Command } from 'common/Prose/Commands'

export const deleteFirstCodeCharacter: Command = ({ schema, selection: { $from, empty }, tr }, dispatch) => {
  if (!empty) return false
  if (
    !(
      schema.marks.code.isInSet($from.nodeAfter?.marks || []) &&
      !schema.marks.code.isInSet($from.nodeBefore?.marks || [])
    )
  )
    return false

  tr.delete($from.pos, $from.pos + 1)
  dispatch?.(tr)

  return true
}
